<ngx-datatable
    [rows]="data"
    [sortType]="'single'"
    [columnMode]="'force'"
    [rowHeight]="40"
    [scrollbarV]="true"
    [sorts]="[{prop: 'points', dir: 'desc'}]">
  <ngx-datatable-column prop="player" name="{{ 'Player' | translate }}" headerClass="player" cellClass="player" [sortable]="!!false" [draggable]="!!false"  [resizeable]="!!false">
    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
      <div class="badge" [class.frontline]="row.player.frontline">
        <img [src]="row.player.image" (error)="onImageError($event)" class="photo" />
      </div>
      <span class="name">{{ row.player.number }}. {{ this.utils.getPlayerShortName(row.player.name) }}</span>
      <span class="tooltip">
        <span class="name">{{ row.player.name }}</span> {{ row.player.frontline ? ('(First team)' | translate) : '' }}
        <span class="position">{{ (getPlayerPosition(row.player.position) | translate) | uppercase }}</span></span>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column prop="points" name="{{ 'Points' | translate }}" [draggable]="!!false"  [resizeable]="!!false"></ngx-datatable-column>
  <ngx-datatable-column prop="rebounds" name="{{ 'Rebounds' | translate }}" headerClass="rebounds" cellClass="rebounds" [draggable]="!!false"  [resizeable]="!!false">
    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
      <span>{{ row.rebounds }}</span>
      <span class="tooltip">{{ 'Defensive + offensive rebounds' | translate }}</span>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column prop="assists" name="{{ 'Assists ' | translate }}" [draggable]="!!false"  [resizeable]="!!false">
    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
      <span>{{ row.assists }}</span>
      <span class="tooltip">{{ 'Assists' | translate }}</span>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column prop="played_time" name="{{ 'Time' | translate }}" [draggable]="!!false"  [resizeable]="!!false">
    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
      {{ (row.played_time * 1000) | date:'mm:ss' }}
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column prop="fouls" name="{{ 'Fouls' | translate }}" headerClass="fouls" cellClass="fouls" [draggable]="!!false"  [resizeable]="!!false">
    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
      <span [class.active]="row.fouls > 0">{{ row.fouls }}</span>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column prop="rating" name="{{ 'Rating' | translate }}" headerClass="rating" cellClass="rating" [draggable]="!!false"  [resizeable]="!!false">
    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
      <span>{{ row.rating }}</span>
      <span class="tooltip">{{ 'Performance Index Rating' | translate }}</span>
    </ng-template>
  </ngx-datatable-column>
</ngx-datatable>
